import './promotion.scss'
import React from 'react'
import { IonItemGroup } from '@ionic/react'
import TopBaner from '../TopBaner/TopBaner'
import QuickButtons from './QuickButtons/QuickButtons'
import { connectPromotions } from './Promotion.connect'
import { useEffect } from 'react'
import SportsButtons from './SportButtons/SportsButtons'
import {
  HeaderCasino,
  HeaderCasinoGap,
} from '../../constants/Casino/HeaderCasino'
import HomeTopCasino from '../../pages/DefaultPage/HomeTopCasino'
import { useSelector } from 'react-redux'
import { IS_MAHADEV } from '../../config/api.config'

const Promotion = ({ inplayPopular, promotions, menuTop, actions, auth }) => {
  useEffect(() => {
    if (auth) {
      actions.requestPromotions()
      actions.requestSocials()
    }
  }, [auth])

  useEffect(() => {
    actions.getEnabledMobile()
  }, [])

  const activeSportList = useSelector((state) => state?.menuTop)

  const isSportAvailable = (id) => {
    return activeSportList?.some((sport) => sport.sport_id === id)
  }

  return (
    <>
      {promotions ? (
        <IonItemGroup className="promotion-content">
          {promotions?.slider && promotions?.slider.length >= 1 ? (
            <TopBaner inPlaySlidingBanners={promotions?.slider} />
          ) : (
            ''
          )}
          {menuTop && menuTop.length >= 1 ? (
            <SportsButtons sportsButtons={menuTop} />
          ) : (
            ''
          )}
          {(isSportAvailable('QT') || isSportAvailable('GAP')) &&
            IS_MAHADEV && <HomeTopCasino isSportAvailable={isSportAvailable} />}
          {(isSportAvailable('QT') ? HeaderCasino : HeaderCasinoGap) &&
          (isSportAvailable('QT') ? HeaderCasino : HeaderCasinoGap).length >=
            1 ? (
            <QuickButtons
              quickButtons={
                isSportAvailable('QT') ? HeaderCasino : HeaderCasinoGap
              }
              auth={auth}
              isSportAvailable={isSportAvailable}
            />
          ) : (
            ''
          )}
        </IonItemGroup>
      ) : (
        ''
      )}
    </>
  )
}

export default connectPromotions()(Promotion)
